export interface SegmentPixelProps {
    id: string;
}

export const SegmentPixel = ({ id }: SegmentPixelProps) => (
    <img src={`https://secure.adnxs.com/seg?add=${id}&t=1`} alt="" height={0} width={0} />
);

SegmentPixel.displayName = 'SegmentPixel';
